module.exports = __webpack_public_path__ + "img/giftcard.461faf4e.jpg";